module.exports = __webpack_public_path__ + "img/bow-tie-1.a60daa4e.svg";